import React, { useState, useEffect,useRef } from "react";
import OneImg from "../Assets/images/100.svg";
import TwoImg from "../Assets/images/52.svg";
import ThreeImg from "../Assets/images/48.svg";
import GraphOne from "../Assets/images/graph-1.png";
import FilterNew from "../Assets/images/filter-new.svg";
import TwoGraph from "../Assets/images/two.png";
import { Table } from "antd";
import { useLocation } from "react-router-dom";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";

import { Flex, Progress } from "antd";
import CircularProgressBar from "./CircularProgressBar";
import {
  Tabs,
  Dropdown,
  Menu,
  Modal,
  Form,
  Input,
  Button,
  Select,
  Checkbox,
} from "antd";
import { useSnapshot } from "./SnapshotContext";

const UniqueAreaDashboard = ({ parkingDemandData }) => {
  const [showFilterDetails, setShowFilterDetails] = useState(false);

  const [isCustomEnabled, setIsCustomEnabled] = useState(false);
  const [activeTableParking, setActiveTableParking] = useState("weekday");
  const [forceRender, setForceRender] = useState(false);

  // const { addSnapshotRef, takeMultipleSnapshots } = useSnapshot();
  const { addSnapshotRef, UniqueremoveSnapshotRef } = useSnapshot();
  const weekendUniqueBarGraphSnap = useRef();
  const weekdayUniqueBarGraphSnap = useRef();
  const weekdayUniqueLineGraphSnap =useRef();
  const weekendUniqueLineGraphSnap = useRef();
  const parkingDistibutionTable = useRef();  


  useEffect(() => {
    UniqueremoveSnapshotRef()
    // UniqueremoveSnapshotRef("weekendUniqueBarGraphSnap");
    // UniqueremoveSnapshotRef("weekdayUniqueBarGraphSnap");
    // UniqueremoveSnapshotRef("weekdayUniqueLineGraphSnap");
    // UniqueremoveSnapshotRef("weekendUniqueLineGraphSnap");
    

    // if (activeTableParking === "weekend"){
    // addSnapshotRef("weekendUniqueBarGraphSnap", weekendUniqueBarGraphSnap.current);
    // addSnapshotRef("weekendUniqueLineGraphSnap",weekendUniqueLineGraphSnap.current);
    // }
    // if (activeTableParking === "weekday"){
    // addSnapshotRef("weekdayUniqueLineGraphSnap",weekdayUniqueLineGraphSnap.current);
    // addSnapshotRef("weekdayUniqueBarGraphSnap", weekdayUniqueBarGraphSnap.current);
    
    // }
    if (activeTableParking === "weekend") {
      addSnapshotRef("weekendUniqueBarGraphSnap", weekendUniqueBarGraphSnap.current);
      addSnapshotRef("weekendUniqueLineGraphSnap", weekendUniqueLineGraphSnap.current);
      
    } else {
      addSnapshotRef("weekdayUniqueLineGraphSnap", weekdayUniqueLineGraphSnap.current);
      addSnapshotRef("weekdayUniqueBarGraphSnap", weekdayUniqueBarGraphSnap.current);
    }
    addSnapshotRef("parkingDistibutionTable", parkingDistibutionTable.current);
    // Force re-render to ensure graphs update properly
    setForceRender(prev => !prev);

  }, [addSnapshotRef,UniqueremoveSnapshotRef,activeTableParking]);

  // const [activeTableMonthly, setActiveTableMonthly] = useState("monthly");

  const toggleFilterDetails = () => {
    setShowFilterDetails((prev) => !prev);
  };

  // console.log("Parking Demand Data Unique AREA Dashboard:", parkingDemandData);
  //   console.log("weekendParkingDemandData:", weekendParkingDemandData);

  const {
    weekend,
    weekday,
    land_use_type = "N/A",
    description = "N/A",
  } = parkingDemandData;

  const formatData = (data) => ({
    peakHour: data?.peak_hour_time || "",
    peakHourValue: data?.peak_hour || "",
    peakMonth: data?.peak_month_name || "",
    peakMonthValue: data?.peak_month || "",
  });

  const weekdayData = formatData(weekday);
  const weekendData = formatData(weekend);
  // Extract data for the month graph
  const monthGraphData = parkingDemandData?.weekday.month_graph;

  // Format the data for Recharts
  const formattedData = monthGraphData?.months.map((month, index) => ({
    month,
    peakDemand: monthGraphData.peak_monthly_distribution[index],
  }));

  // console.log("formattedData For Unique::",formattedData);
  

  const timeGraphData = parkingDemandData.weekday.time_graph;

  const formattedTimeData = timeGraphData?.time_labels.map((labels, index) => ({
    time: labels,
    peakDemand: timeGraphData.peak_demand_points[index],
  }));

  const monthGraphWeekendData = parkingDemandData.weekend.month_graph;
  // console.log("monthGraphWeekendData::", monthGraphWeekendData);

  const formattedWeekendData = monthGraphWeekendData?.months.map(
    (month, index) => ({
      month,
      peakDemand: monthGraphWeekendData.peak_monthly_distribution[index],
    })
  );

  const timeGraphWeekendData = parkingDemandData.weekend.time_graph;

  const formattedTimeWeekendData = timeGraphWeekendData?.time_labels.map(
    (labels, index) => ({
      time: labels,
      peakDemand: timeGraphWeekendData.peak_demand_points[index],
    })
  );

  // console.log("formattedWeekendData::", formattedWeekendData);

  // console.log("formattedTimeData::", formattedTimeData);

  // console.log("timeGraphData::", timeGraphData);

  const handleCheckboxChange = (e) => {
    setIsCustomEnabled(e.target.checked);
  };

  const onChanges = (value) => {
    // console.log(`selected ${value}`);
  };
  const onSearch = (value) => {
    // console.log("search:", value);
  };


  const columnOfWeekdays = [
    {
      title: "Month ",
      dataIndex: "month",
      key: "month",
      // width: 130,
      align: "center",
    },
  ];
  // Dynamically generate columns based on the months
  const columns = [
    ...columnOfWeekdays,
    ...parkingDemandData.overall_distribution.weekday.time_slots.map(
      (time, index) => ({
        title: time,
        dataIndex: `time_${index + 1}`,
        key: `time_${index + 1}`,
        align: "center",
      })
    ),
  ];

  const columns_Weekend = [
    ...columnOfWeekdays,
    ...parkingDemandData.overall_distribution.weekend.time_slots.map(
      (time, index) => ({
        title: time,
        dataIndex: `time_${index + 1}`,
        key: `time_${index + 1}`,
        align: "center",
      })
    ),
  ];

  // Generate dataSource dynamically
  const dataSource = parkingDemandData.overall_distribution.weekday.months.map(
    (month, rowIndex) => {
      const row = { key: rowIndex, month }; // Month as the first column
      parkingDemandData.overall_distribution.weekday.distribution_matrix[
        rowIndex
      ].forEach((value, colIndex) => {
        row[`time_${colIndex + 1}`] = value; // Fill subsequent columns with matrix values
      });
      return row;
    }
  );

  // console.log("dataSource::::", dataSource);

  const dataSource_WeekendTable =
    parkingDemandData.overall_distribution.weekend.months.map(
      (month, rowIndex) => {
        const row = { key: rowIndex, month }; // Month as the first column
        parkingDemandData.overall_distribution.weekend.distribution_matrix[
          rowIndex
        ].forEach((value, colIndex) => {
          row[`time_${colIndex + 1}`] = value; // Fill subsequent columns with matrix values
        });
        return row;
      }
    );

  // console.log("Generated DataSource:", dataSource);

  // Table data
  const dataSourceForIndividalTable = [
    {
      key: "1",
      landUse: "Retail (<400ksf)",
      quantity: "1000",
      peakHrWeekday: "12PM",
      peakNoAdjWeekday: "December",
      peakHrWeekend: "12PM",
      peakNoAdjWeekend: "December",
    },
  ];

  const columnsForIndividalTable = [
    {
      title: "Parking Demand Summary", // First row
      align: "center",
      colSpan: 7, // Spans across all columns
      children: [
        {
          title: "Peak Month: December", // Second row
          align: "center",
          colSpan: 7, // Spans across all columns
          children: [
            {
              title: "Land Use", // Third row
              dataIndex: "landUse",
              key: "landUse",
              align: "top",
            },
            {
              title: "Project Data",
              dataIndex: "quantity",
              key: "quantity",
              align: "top",
            },
            {
              title: "Weekday", // Empty column to create space for Weekday's children in the next row
              align: "center",
              colSpan: 2,
              children: [
                {
                  title: "Peak Hr",
                  dataIndex: "peakHrWeekday",
                  key: "peakHrWeekday",
                  align: "center",
                },
                {
                  title: "Peak Mo Adj",
                  dataIndex: "peakNoAdjWeekday",
                  key: "peakNoAdjWeekday",
                  align: "center",
                },
              ],
            },
            {
              title: "Weekend", // Empty column to create space for Weekend's children in the next row
              align: "center",
              colSpan: 2,
              children: [
                {
                  title: "Peak Hr",
                  dataIndex: "peakHrWeekday",
                  key: "peakHrWeekday",
                  align: "center",
                },
                {
                  title: "Peak Mo Adj",
                  dataIndex: "peakNoAdjWeekday",
                  key: "peakNoAdjWeekday",
                  align: "center",
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  return (
    <div>
      <div className="row">
        <div className="col-lg-12 mb-3">
          {/* <div className="d-flex align-items-center">
            <div
              className="d-flex align-items-center"
              style={{
                border: "1px solid #DDDEDF",
                padding: "10px 15px",
                borderRadius: "30px",
                cursor: "pointer",
              }}
              onClick={toggleFilterDetails}
            >
              <img src={FilterNew} className="" />
              <h6 className="mb-0 ms-2">Edit Template</h6>
            </div>
          </div> */}
        </div>
        {showFilterDetails && (
          <div className="col-lg-12  mb-3">
            <div className="card-inside form-style">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center justify-content-start">
                  <h4 className="mb-0 me-4">Filter Details</h4>
                  <Checkbox
                    onChange={handleCheckboxChange}
                    style={{ fontSize: "17px", fontWeight: "500" }}
                  >
                    Use Custom
                  </Checkbox>
                </div>
                {isCustomEnabled && (
                  <button className="btn btn-primary">Calculate</button>
                )}
              </div>
              <div className="">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  {/* <div className="edit-img-round">
                        <img src={EditImg} alt="" />
                        </div> */}
                </div>
                <div className="row">
                  <div className="col">
                    <label htmlFor="">Land Usage Type</label>
                    <Select
                      className="w-100"
                      showSearch
                      placeholder="Select a person"
                      optionFilterProp="label"
                      disabled={!isCustomEnabled}
                      onChanges={onChanges}
                      onSearch={onSearch}
                      options={[
                        {
                          value: ">300",
                          label: ">300",
                        },
                        {
                          value: ">500",
                          label: ">500",
                        },
                        {
                          value: ">800",
                          label: ">800",
                        },
                      ]}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="">Land usage</label>
                    <input
                      type="text"
                      placeholder="Land usage"
                      className="form-control"
                      disabled={!isCustomEnabled}
                      // onChange={(e) => handleFormChange("landUseValue", e.target.value)}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="">Captive Ratio</label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control"
                      value={"100%"}
                      disabled={!isCustomEnabled}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="">Driving Adjustment</label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control"
                      value={"100%"}
                      disabled={!isCustomEnabled}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="">Base Ratio</label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control"
                      disabled={!isCustomEnabled}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="">Monthly Ratio</label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control"
                      disabled={!isCustomEnabled}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="">Time Ratio</label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control"
                      disabled={!isCustomEnabled}
                    />
                  </div>
                </div>

                {/* <div className="row mt-4 show-datas">
                                <div className="col-lg-4">
                                    <label htmlFor="">Base Ratio</label>
                                   <input type="text" placeholder="" className="form-control"  disabled={!isCustomEnabled}  />
                                </div>
                                <div className="col-lg-4">
                                    <label htmlFor="">Monthly Ratio</label>
                                   <input type="text" placeholder="" className="form-control"  disabled={!isCustomEnabled}  />
                                </div>
                                <div className="col-lg-4">
                                    <label htmlFor="">Time Ratio</label>
                                   <input type="text" placeholder="" className="form-control"   disabled={!isCustomEnabled} />
                                </div>
                            </div> */}
                {/* <div className="col-lg-12 text-end mt-4">
                                <button className="btn btn-primary">Calculate</button>
                            </div> */}
              </div>
            </div>
          </div>
        )}
      </div>
      {/*  */}
      {/* <div className="row">
                <div className="col-lg-4">
                    <div className=" card-inside-parking actual-parking-active">
                        <div>
                            <h4>
                                Actual Parking
                            </h4>
                            <h1>
                                100
                            </h1>
                            <p>
                                Sample Description
                            </p>
                        </div>
                        <div>
                      
                <CircularProgressBar percent={75}/>

                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className=" card-inside-parking">
                        <div>
                            <h4>
                            Shared Parking
                            </h4>
                            <h1>
                               52
                            </h1>
                            <p>
                                Sample Description
                            </p>
                        </div>
                        <div>
                           <CircularProgressBar percent={50}/>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className=" card-inside-parking">
                        <div>
                            <h4>
                            Saved Parking
                            </h4>
                            <h1>
                               48
                            </h1>
                            <p>
                                Sample Description
                            </p>
                        </div>
                        <div>
                           <CircularProgressBar percent={25}/>
                        </div>
                    </div>
                </div>
            </div> */}
      <div className="row">
        <div className="col-lg-12">
          <div className="card-inside">
            <div className="d-flex align-items-center justify-content-between">
              <div className="text-left">
                <h4>Parking Demand Summary</h4>
                {/* <h5>
                  Peak Month:{" "}
                  <span className="px-1" style={{ background: "#F6E3D4" }}>
                    {weekendData.peakMonth}
                  </span>{" "}
                  | Peak Period:{" "}
                  <span className="px-1" style={{ background: "#E5E1F3" }}>
                    {weekendData.peakHour}, WEEKEND{" "}
                  </span>
                </h5> */}
              </div>
              <div
                className="d-flex align-items-center"
                style={{ borderRadius: "5px" }}
              >
                {/* Weekday and Weekend buttons */}
                <div
                  onClick={() => setActiveTableParking("weekday")}
                  style={{
                    cursor: "pointer",
                    padding: "18px 40px",
                    fontWeight: "300",
                    background:
                      activeTableParking === "weekday" ? "#a4dec8" : "#ecf4f5",
                    borderRadius: "5px 0 0 5px",
                  }}
                >
                  <h4
                    style={{ fontSize: "15px", fontWeight: "400" }}
                    className="mb-0"
                  >
                    Weekday
                  </h4>
                </div>
                <div
                  onClick={() => setActiveTableParking("weekend")}
                  style={{
                    cursor: "pointer",
                    padding: "18px 40px",
                    fontWeight: "300",
                    background:
                      activeTableParking === "weekend" ? "#a4dec8" : "#ecf4f5",
                    borderRadius: "0 5px 5px 0",
                  }}
                >
                  <h4
                    style={{ fontSize: "15px", fontWeight: "400" }}
                    className="mb-0"
                  >
                    Weekend
                  </h4>
                </div>
              </div>
            </div>
            <div>
              
            {activeTableParking === "weekday" && (
              <div className="row mt-4">
                <div className="col-lg-4">
                  <div
                    className=" card-inside-parking"
                    style={{
                      background:
                        "linear-gradient(180.17deg, #F7F9FB 0.15%, #E8F2F3 99.85%)",
                    }}
                  >
                    <div>
                      <h4>Total Size</h4>
                      <h2>
                      {parkingDemandData.project_data.quantity}  <span style={{ fontSize: "25px" }}>{parkingDemandData.project_data.unit}</span>
                      </h2>
                      
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div
                    className=" card-inside-parking"
                    style={{
                      background:
                        "linear-gradient(180.17deg, #F7F9FB 0.15%, #E8F2F3 99.85%)",
                    }}
                  >
                    <div>
                      <h4>Peak Month & Hour</h4>
                      <h2>
                      {weekdayData.peakMonth} {weekdayData.peakHour} 
                      </h2>
                     
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div
                    className=" card-inside-parking"
                    style={{
                      background:
                        "linear-gradient(180.17deg, #F7F9FB 0.15%, #E8F2F3 99.85%)",
                    }}
                  >
                    <div>
                      <h4>Peak Value</h4>
                      <h2>{weekdayData.peakMonthValue}</h2>
                      
                    </div>
                  </div>
                </div>
              </div>
              )}
               {activeTableParking === "weekend" && (
              <div className="row mt-4">
                <div className="col-lg-4">
                  <div
                    className=" card-inside-parking"
                    style={{
                      background:
                        "linear-gradient(180.17deg, #F7F9FB 0.15%, #E8F2F3 99.85%)",
                    }}
                  >
                    <div>
                      <h4>Total Size</h4>
                      <h2>
                      {parkingDemandData.project_data.quantity}  <span style={{ fontSize: "25px" }}>{parkingDemandData.project_data.unit}</span>
                      </h2>
                      
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div
                    className=" card-inside-parking"
                    style={{
                      background:
                        "linear-gradient(180.17deg, #F7F9FB 0.15%, #E8F2F3 99.85%)",
                    }}
                  >
                    <div>
                      <h4>Peak Month & Hour</h4>
                      <h2>
                      {weekendData.peakMonth} {weekendData.peakHour} 
                      </h2>
                      
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div
                    className=" card-inside-parking"
                    style={{
                      background:
                        "linear-gradient(180.17deg, #F7F9FB 0.15%, #E8F2F3 99.85%)",
                    }}
                  >
                    <div>
                      <h4>Peak Value</h4>
                      <h2>{weekendData.peakMonthValue}</h2>
                      
                    </div>
                  </div>
                </div>
              </div>
              )}
            </div>
            {/* <table className="table mt-4 table-bordered">
              <thead>
                <tr>
                  <td colSpan="2"></td>
                  <td colSpan="3" className="text-center">
                    Weekday
                  </td>
                  <td colSpan="3" className="text-center">
                    Weekend
                  </td>
                </tr>
                <tr>
                  <td>Land Use</td>
                  <td>Total Size</td>
                  <td>Peak Month</td>
                  <td>Peak Hour</td>
                  <td>Peak Value</td>
                  <td>Peak Month</td>
                  <td>Peak Hour</td>
                  <td>Peak Value</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{land_use_type}</td>
                  <td>
                    {parkingDemandData.project_data.quantity}{" "}
                    {parkingDemandData.project_data.unit}
                  </td>
                  <td style={{ background: "#F6E3D4" }}>
                    {weekdayData.peakMonth}
                  </td>
                  <td>{weekdayData.peakHour}</td>
                  <td>{weekdayData.peakMonthValue}</td>
                  <td>{weekendData.peakMonth}</td>
                  <td style={{ background: "#E5E1F3" }}>
                    {weekendData.peakHour}
                  </td>
                  <td>{weekendData.peakMonthValue}</td>
                </tr>
              </tbody>
            </table> */}
          </div>
        </div>
      </div>
     
      <div className="row mt-3">
      {activeTableParking === "weekday" && (<>
        <div ref={weekdayUniqueBarGraphSnap} className="col-lg-6">
          <div className="card-inside">
            <h4>
              {/* Month by Month estimated parking demand(Weekend)  */}
              {/* {parkingDemandData.weekday.month_graph.title} */}
              Weekday Peak Month Parking Distribution
            </h4>
            <div className="graph-section mt-5">
              {/* <img src={GraphOne} alt="" className="w-100" /> */}
              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  data={formattedData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  <defs>
                    <linearGradient
                      id="greenGradient"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop offset="5%" stopColor="#66bb6a" stopOpacity={0.8} />
                      <stop
                        offset="95%"
                        stopColor="#388e3c"
                        stopOpacity={0.8}
                      />
                    </linearGradient>
                  </defs>
                  <CartesianGrid
                    strokeDasharray="9 9"
                    vertical={false}
                    strokeOpacity={0.6}
                  />
                  <XAxis dataKey="month" tickLine={false} dy={5} interval={0}/>
                  <YAxis
                    // label={{ value: monthGraphData.y_axis, angle: -90, position: 'insideLeft' }}
                    axisLine={false}
                    tickLine={false}
                    dx={-25}
                  />
                  <Tooltip />
                  <Legend />
                  <Bar
                    dataKey="peakDemand"
                    fill="url(#greenGradient)"
                    name="Peak Demand"
                    barSize={27}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
        <div ref={weekdayUniqueLineGraphSnap} className="col-lg-6">
          <div className="card-inside">
            <h4>
              {/* Peak month daily parking demand by hour(Weekend) */}
              {/* {parkingDemandData.weekday.time_graph.title} */}
              Hourly Distribution of Weekday Peak Parking Demand
            </h4>
            <div className="graph-section mt-5">
              <ResponsiveContainer width="100%" height={400}>
                <LineChart
                  data={formattedTimeData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  <defs>
                    <linearGradient
                      id="lineGradient"
                      x1="0"
                      y1="0"
                      x2="1"
                      y2="0"
                    >
                      <stop offset="5%" stopColor="#66bb6a" stopOpacity={0.8} />
                      <stop
                        offset="95%"
                        stopColor="#388e3c"
                        stopOpacity={0.8}
                      />
                    </linearGradient>
                  </defs>
                  <CartesianGrid
                    strokeDasharray="9 9"
                    vertical={false}
                    strokeOpacity={0.6}
                  />
                  <XAxis
                    dataKey="time"
                    tickLine={false}
                    // interval={1}
                    // dx={10}
                    dy={5}
                  />
                  <YAxis axisLine={false} tickLine={false} dx={-25} />
                  <Tooltip />
                  <Legend />
                  <Line
                    type="monotone"
                    dataKey="peakDemand"
                    stroke="url(#lineGradient)"
                    name="Peak Demand"
                    strokeWidth={2}
                    dot={false}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
        </>
      )}


      {activeTableParking === "weekend" && (<>
        <div ref={weekendUniqueBarGraphSnap} className="col-lg-6 mt-3">
          <div className="card-inside">
            <h4>
              {/* Month by Month estimated parking demand(Weekend)  */}
              {/* {parkingDemandData.weekend.month_graph.title} */}
              Weekend Peak Month Parking Distribution
            </h4>
            <div className="graph-section mt-5">
              {/* <img src={GraphOne} alt="" className="w-100" /> */}
              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  data={formattedWeekendData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  <defs>
                    <linearGradient
                      id="blueGradient"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop offset="5%" stopColor="#4f83cc" stopOpacity={0.8} />
                      <stop
                        offset="95%"
                        stopColor="#1c4e80"
                        stopOpacity={0.8}
                      />
                    </linearGradient>
                  </defs>
                  <CartesianGrid
                    strokeDasharray="9 9"
                    vertical={false}
                    strokeOpacity={0.6}
                  />
                  <XAxis dataKey="month" tickLine={false} dy={5} />
                  <YAxis
                    // label={{ value: monthGraphData.y_axis, angle: -90, position: 'insideLeft' }}
                    axisLine={false}
                    tickLine={false}
                    dx={-25}
                  />
                  <Tooltip />
                  <Legend />
                  <Bar
                    dataKey="peakDemand"
                    fill="url(#blueGradient)"
                    name="Peak Demand"
                    barSize={27}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
        
        <div ref={weekendUniqueLineGraphSnap} className="col-lg-6 mt-3">
          <div className="card-inside">
            <h4>
              {/* Peak month daily parking demand by hour(Weekend) */}
              {/* {parkingDemandData.weekend.time_graph.title} */}
              Hourly Distribution of Weekend Peak Parking Demand
            </h4>
            <div className="graph-section mt-5">
              <ResponsiveContainer width="100%" height={400}>
                <LineChart
                  data={formattedTimeWeekendData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  <defs>
                    <linearGradient
                      // id="lineGradient"
                      id="blueGradient"
                      x1="0"
                      y1="0"
                      x2="1"
                      y2="0"
                    >
                      <stop offset="5%" stopColor="#4f83cc" stopOpacity={0.8} />
                      <stop
                        offset="95%"
                        stopColor="#1c4e80"
                        stopOpacity={0.8}
                      />
                    </linearGradient>
                  </defs>
                  <CartesianGrid
                    strokeDasharray="9 9"
                    vertical={false}
                    strokeOpacity={0.6}
                  />
                  <XAxis
                    dataKey="time"
                    tickLine={false}
                    // interval={1}
                    // dx={10}
                    dy={5}
                  />
                  <YAxis axisLine={false} tickLine={false} dx={-25} />
                  <Tooltip />
                  <Legend />
                  <Line
                    type="monotone"
                    dataKey="peakDemand"
                    stroke="url(#blueGradient)"
                    name="Peak Demand"
                    strokeWidth={2}
                    dot={false}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
        </>
        )}
    

        {/* <div className="col-lg-6 mt-3">
                    <div className="card-inside">
                        <h4>
                        Parking Distribution
                        </h4>
                        <div className="table-section mt-5">
                        <Table
        dataSource={dataSourceForIndividalTable}
        columns={columnsForIndividalTable}
        pagination={false} // Disable pagination
        bordered // Add table borders
        style={{ margin: "20px 0" }}
      />  
                        </div>
                        
                    </div>
                </div> */}

        {/* <div className="col-lg-6 mt-3">
          <div className="card-inside">
            <h4>Weekday Parking Distribution</h4>
            <div className="table-section mt-5">
              <Table
                dataSource={dataSource}
                columns={columns}
                scroll={{
                  x: "max-content",
                }}
                pagination={{ pageSize: 15 }}
                rowClassName={(record) =>
                  record.month === parkingDemandData.weekday.peak_month_name
                    ? "highlight-row"
                    : ""
                }
              />
            </div>
          </div>
        </div> */}
        <div className="col-lg-12 mt-3">
          <div className="card-inside">
            <div className="d-flex align-items-center justify-content-between w-100">
              <div>
                <h4>Parking Distribution</h4>
                {activeTableParking === "weekend" && <p>Weekend</p>}
                {activeTableParking === "weekday" && <p>Weekday</p>}
              </div>
              <div
                className="d-flex align-items-center"
                style={{ borderRadius: "5px" }}
              >
               
                {/* <div
                  onClick={() => setActiveTableParking("weekday")}
                  style={{
                    cursor: "pointer",
                    padding: "18px 40px",
                    fontWeight: "300",
                    background:
                      activeTableParking === "weekday" ? "#A4DEC8" : "#ECF4F5",
                    borderRadius: "5px 0 0 5px",
                  }}
                >
                  <h4
                    style={{ fontSize: "15px", fontWeight: "400" }}
                    className="mb-0"
                  >
                    Weekday
                  </h4>
                </div>
                <div
                  onClick={() => setActiveTableParking("weekend")}
                  style={{
                    cursor: "pointer",
                    padding: "18px 40px",
                    fontWeight: "300",
                    background:
                      activeTableParking === "weekend" ? "#A4DEC8" : "#ECF4F5",
                    borderRadius: "0 5px 5px 0",
                  }}
                >
                  <h4
                    style={{ fontSize: "15px", fontWeight: "400" }}
                    className="mb-0"
                  >
                    Weekend
                  </h4>
                </div> */}
              </div>
            </div>
            {/*  */}

            <div ref={parkingDistibutionTable} 
            style={{ backgroundColor: "#f8f9fa"}}>
              {activeTableParking === "weekday" && (
                <Table
                  dataSource={dataSource}
                  columns={columns}
                  scroll={{
                    x: "max-content",
                  }}
                  pagination={dataSource.length > 15 ? { pageSize: 15 } : false}
                  rowClassName={(record) =>
                    record.month === parkingDemandData.weekday.peak_month_name
                      ? "highlight-row"
                      : ""
                  }
                />
              )}
              {activeTableParking === "weekend" && (
                <Table
                  dataSource={dataSource_WeekendTable}
                  columns={columns_Weekend}
                  scroll={{
                    x: "max-content",
                  }}
                  pagination={dataSource.length > 15 ? { pageSize: 15 } : false}
                  rowClassName={(record) =>
                    record.month === parkingDemandData.weekend.peak_month_name
                      ? "highlight-row"
                      : ""
                  }
                />
              )}
            </div>

            {/*  */}
          </div>
        </div>
        {/* <div className="col-lg-6 mt-3">
          <div className="card-inside">
            <h4>Weekend Parking Distribution</h4>
            <div className="table-section mt-5">
              <Table
                dataSource={dataSource_WeekendTable}
                columns={columns_Weekend}
                scroll={{
                  x: "max-content",
                }}
                pagination={{ pageSize: 15 }}
                rowClassName={(record) =>
                  record.month === parkingDemandData.weekend.peak_month_name
                    ? "highlight-row"
                    : ""
                }
              />
            </div>
          </div>
        </div> */}

        {/* <div className="col-lg-6 mt-4">
                    <div className="card-inside">
                        <h4>
                        Month by Month estimated parking demand(Day) 
                        </h4>
                        <div className="graph-section mt-5">
                            <img src={GraphOne} alt="" className="w-100" />
                        </div>
                        <div className="w-100 text-center mt-4" style={{color: '#73878D'}}>
                            <p>
                            Sample Description
                            </p>
                        </div>
                    </div>
                </div> */}
      </div>
    </div>
  );
};

export default UniqueAreaDashboard;
